module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-aquarium-in-houston-texas-a1f873aa50c21c9ee5c1bb94f4c9a171.png";